import ContainerLayout from '@/components/Layout/ContainerLayout';
import { Paper } from '@/components/Paper';
import { useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useFetchList } from './service'; 
import { Spinner, Box, Icon, HStack,Text } from '@chakra-ui/react';
import { WrapperTable } from '@/components/WrapperTable';
import Pagination from '@/components/Paginator';
import SlimTable from '../components/SlimTable';
import { headers, mockData } from './settings';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { FaClock, FaRegCalendarAlt } from 'react-icons/fa';


function FilaDeCarga() {
  const [visibleHeaders, setVisibleHeaders] = useState(headers);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);


  const printRef = useRef(null);

  const { data, isLoading } = useFetchList({
    page: currentPage - 1,
    size: 20,
    totalCount: 0,
    search: {}, 
  });
  

  return (
    <ContainerLayout>
      <Paper
        m={6}
        bg="white"
        py={4}
        px={2}
        rounded="xl"
        shadow="sm"
        border="1px solid rgba(200, 200, 200, .4)"
        h={'94%'}
      >
       <HStack
             justify="space-between"
             border={"2px"}
             align={'center'}
             borderBottom={"2px"}
             borderColor="#0f4f6d"
             borderRadius={"xl"}
             p={2}
           >
             <HStack>
               <Icon boxSize={6} as={IoMdCheckmarkCircleOutline} />
               <Text fontWeight="bold" fontSize={'xl'}>
                 Acompanhamento Portaria - Fila de Carga
               </Text>
             </HStack>
              <HStack spacing={4} align="center">
                <HStack spacing={2} align="center">
                  <Box as={FaRegCalendarAlt} boxSize={6} color={'rgba(15, 79, 109, 1)'}/>
                  <Text fontSize={'md'} fontWeight={'bold'} >Data: {new Date().toLocaleDateString()}</Text>
                </HStack>
                <HStack spacing={2} align="center">
                  <Box as={FaClock} boxSize={6} color={'rgba(15, 79, 109, 1)'}/>
                    <Text fontSize={'md'} fontWeight={'bold'}>
                    Hora: {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </Text>
                </HStack>
              </HStack>

        </HStack>

        <WrapperTable  ref={printRef}>
          {isLoading ? (
            <Box py={10} textAlign="center">
              <Spinner size="lg" />
            </Box>
          ) : (
            <SlimTable
              headers={visibleHeaders}
              showActions={false}
              data={mockData}
              maxHeight={'700px'}
            />
            
          )}
        </WrapperTable>
        <Outlet />
      </Paper>
    </ContainerLayout>
  );
}

export default FilaDeCarga;
